export function getGoogleMapsUrl(playground) {
  const params = new URLSearchParams({
    api: "1",
    query: playground.name,
    query_place_id: playground.id,
  });
  return `https://www.google.com/maps/search/?${params.toString()}`;
}

export function getGooglePlacePhotoUrl(photoReference, maxWidth = 400) {
  const params = new URLSearchParams({
    maxwidth: String(maxWidth),
    photo_reference: photoReference,
    key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });
  return `https://maps.googleapis.com/maps/api/place/photo?${params.toString()}`;
}
